import qs from "query-string"
import * as Util from "../common"
import withProps from "recompose/withProps"

export default withProps(({location, history}) => {
  const query = qs.parse(location.search)
  switch (query.mode) {
    case "resetPassword":
      history.replace("/auth/reset/" + query.oobCode)
      break
    default:
      break
  }
  return null
})(Util.NotFoundView)



// WEBPACK FOOTER //
// ./src/auth-signin/AuthEmailActionRedirect.js